// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import Close from '../_raw/ui/icon_clear.svg';

export default withIconProps(Close, { shouldSetDefaultSize: false });
